import { useTranslation } from "react-i18next";
import { Badge } from "components/ui/badge";
import { Link2 } from "lucide-react";
import { Button } from "components/button";
import { Text } from "components/text";

interface ManuscriptDetailsHeaderProps {
  filename: string;
  onExportClick: () => void;
}

export const ManuscriptDetailsHeader: React.FC<
  ManuscriptDetailsHeaderProps
> = ({ filename, onExportClick }) => {
  const { t } = useTranslation(["manuscriptDetails"]);

  return (
    <div className="flex justify-between">
      <div className="flex flex-col gap-2">
        <Text as="h1" variant="pageHeading" data-testid="manuscript-title">
          {filename || t("manuscriptDetails:header.unknownFilename")}
        </Text>
        {filename && (
          <Badge
            variant="secondary"
            className="flex items-center gap-1 max-w-max"
            data-testid="manuscript-filename"
          >
            <Link2 size={14} />
            <span className="truncate max-w-xs">{filename}</span>
          </Badge>
        )}
      </div>
      <div>
        <Button
          variant="primary"
          label={t("manuscriptDetails:header.export")}
          icon="download"
          onClick={onExportClick}
          size="small"
          analyticsId="button_export_xls"
        />
      </div>
    </div>
  );
};
